import React from 'react'
import Routes from './Routes'

export default () => (
    <div>
        <div>
            <Routes />
        </div>
    </div>
)


// WEBPACK FOOTER //
// ./src/display/features/ui/components/App.js